var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.breadcrumb)}}),_vm._v(" "),(_vm.isProduct)?_c('span',[_vm._v(" "+_vm._s(_vm.currentProduct.name))]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('a',{attrs:{"href":"/products"}},[_vm._v("Shop")]),_vm._v(" /")])
}]

export { render, staticRenderFns }